import type from './SystemMasters.type';

const initialState = {
  brandList: [],
  finalList: [],
  seasonList: [],
  category1List: [],
  category2List: [],
  category3List: [],
  category4List: [],
  lengthsList: [],
  compositionsList: [],
  mainSampleList: [],
  pcTypeList: [],
  otherSamplesList: [],
  poSizeList: [],
  BOMTypeList: [],
  BOMSubTypeList: [],
  BOMComTypeList: [],
  productStatusList: [],
  unitList: [],
  customizableData: [],
  customAccordianData: [],
  sample_tracking: [],
  sample_status: [],
  measurement_master: [],
  placement_master: [],
  category3ListFrom4: false,
  customAttributeList: [],
  partnerOverviewCustomAttributeList: [],
  multipleCategory3: [],
  multipleCategory4: [],
  exchangeRateData: null,
  userAccessBrands: [],
  userAccessCategories1: [],
  userAccessCategories2: [],
  portOfLandingList: [],
  selectCostingStageList: [],
  productGroupList: [],
  documentTypeList: [],
  productIdentifierList: [],
  identifierType: null,
  testTypeMaster: [],
  damAttributeDropdownList: [],
  bomSubComponentType: [],
  supplierStatusList: [],
  autoIdMaster: [],
  ProductCountList: '',
  pcpCustomAttribute: [],
  customAttributeBomList: [],
  customAttributeSubBomList: [],
  catOptions3: [],
  catOptions4: [],
  lengthVisible: true, // Added lengthVisible with default value true
  lengthInUse: false,
  lengthUsageModules: {},
  variableOneName: '',
  licensorList: [],
  licenseList: [],
  licenseDropdownList: [],
  likenessList: [],
  subBrandAccess: false,
  multiSubBrandList: [],
  incotermsList: [],
  activeIncotermsList: [],
  customAttributeDetail: [],
  placementNames: [],
  catBasedOnPT: false,
  bomSourceCustomAttribute: [],
  colourGroupsList: [],
  compositionMasterData: [],
  bomComponentTypeData: [],
  productTypeProcessData: [],
  moduleOrderConfigs: [],
  sampleTypeGroupList: [],
  additionalVariablesList: [],
  sizeRangesMasterList: [],
  pcTypeAdminList: [],
  filterSeasonList: [],
};

// eslint-disable-next-line default-param-last
const SystemMastersReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.GET_ALL_BRANDS:
      return {
        ...state,
        brandList: action.payload,
      };
    case type.GET_ALL_SEASONS:
      return {
        ...state,
        seasonList: action.payload,
      };
    case type.GET_ALL_FINISHES:
      return {
        ...state,
        finalList: action?.payload ? action.payload : [],
      };
    case type.GET_ACCORDIAN:
      return {
        ...state,
        customizableData: action.payload,
      };
    case type.GET_ALL_CUSTOM_ACCORIAN:
      return {
        ...state,
        customAccordianData: action.payload,
      };
    case type.GET_ALL_CATEGORY_1:
      return {
        ...state,
        category1List: action.payload,
      };
    case type.GET_ALL_CATEGORY_2:
      return {
        ...state,
        category2List: action.payload,
      };
    case type.GET_ALL_CATEGORY_3:
      return {
        ...state,
        category3List: action.payload.data,
        category3ListFrom4: action.payload.fromCategory4,
      };
    case type.GET_ALL_CATEGORY_4:
      return {
        ...state,
        category4List: action.payload,
      };
    case type.GET_ALL_LENGTHS:
      return {
        ...state,
        lengthsList: action.payload,
      };
    case type.GET_ALL_COMPOSITIONS:
      return {
        ...state,
        compositionsList: action.payload,
      };
    case type.GET_ALL_MAIN_SAMPLE:
      return {
        ...state,
        mainSampleList: action.payload,
      };
    case type.GET_ALL_PC_TYPE:
      return {
        ...state,
        pcTypeList: action.payload,
      };
    case type.GET_ALL_OTHER_SAMPLES:
      return {
        ...state,
        otherSamplesList: action.payload,
      };
    case type.GET_ALL_PO_SIZE_MASTER:
      return {
        ...state,
        poSizeList: action.payload,
      };
    case type.GET_ALL_BOM_TYPE_MASTER:
      return {
        ...state,
        BOMTypeList: action.payload,
      };
    case type.GET_ALL_BOM_SUB_TYPE_MASTER:
      return {
        ...state,
        BOMSubTypeList: action.payload,
      };
    case type.GET_ALL_BOM_COMPONENT_TYPE_MASTER:
      return {
        ...state,
        BOMComTypeList: action.payload,
      };
    case type.GET_ALL_PRODUCT_STATUS_MASTER:
      return {
        ...state,
        productStatusList: action.payload,
      };
    case type.GET_ALL_UNIT_MASTER:
      return {
        ...state,
        unitList: action.payload,
      };
    case type.GET_SAMPLE_TRACKING:
      return {
        ...state,
        sample_tracking: action.payload,
      };
    case type.GET_SAMPLE_STATUS:
      return {
        ...state,
        sample_status: action.payload,
      };
    case type.GET_MEASUREMENT:
      return {
        ...state,
        measurement_master: action.payload,
      };
    case type.CUSTOM_ATTRIBUTE_LIST:
      return {
        ...state,
        customAttributeList: action.payload,
      };
    case type.PARTNER_OVERVIEW_CUSTOM_ATTRIBUTE_LIST:
      return {
        ...state,
        partnerOverviewCustomAttributeList: action.payload,
      };
    case type.SET_EXCHANGE_RATE_DATA:
      return {
        ...state,
        exchangeRateData: action.payload,
      };
    case type.GET_MULTIPLE_CATEGORY_3:
      return {
        ...state,
        multipleCategory3: action.payload,
      };
    case type.GET_MULTIPLE_CATEGORY_4:
      return {
        ...state,
        multipleCategory4: action.payload,
      };

    case type.GET_PLACEMENT:
      return {
        ...state,
        placement_master: action.payload,
      };
    case type.GET_USER_BRANDS:
      return {
        ...state,
        userAccessBrands: action.payload,
      };
    case type.GET_USER_CATEGORIES1:
      return {
        ...state,
        userAccessCategories1: action.payload,
      };
    case type.GET_USER_CATEGORIES2:
      return {
        ...state,
        userAccessCategories2: action.payload,
      };
    case type.ALL_PORT_OF_LANDING:
      return {
        ...state,
        portOfLandingList: action.payload,
      };
    case type.UNMOUNT_SYSTEM_MASTER:
      return {
        ...state,
        category3List: [],
        category4List: [],
      };
    case type.GET_COSTING_STAGE:
      return {
        ...state,
        selectCostingStageList: action.payload,
      };
    case type.GET_PRODUCT_GROUP:
      return {
        ...state,
        productGroupList: action.payload,
      };

    case type.GET_DOCUMENT_TYPE:
      return {
        ...state,
        documentTypeList: action.payload,
      };
    case type.GET_PRODUCT_IDENTIFIER:
      return {
        ...state,
        productIdentifierList: action.payload,
      };
    case type.IDENTIFIER_TYPE:
      return {
        ...state,
        identifierType: action.payload,
      };
    case type.CLEAR_SYSTEM_MASTER:
      return {
        ...state,
        sample_tracking: [],
      };
    case type.GET_TEST_TYPE_MASTER:
      return {
        ...state,
        testTypeMaster: action.payload,
      };
    case type.DAM_ATTRIBUTE_DROPDOWN_LIST:
      return {
        ...state,
        damAttributeDropdownList: action.payload,
      };
    case type.DAM_ATTRIBUTE_TEXT_LIST:
      return {
        ...state,
        damAttributeTextList: action.payload,
      };
    case type.UNMOUNT_DOCUMENT_MASTER:
      return {
        ...state,
        documentTypeList: [],
      };
    case type.GET_SUPPLIER_STATUS:
      return {
        ...state,
        supplierStatusList: action.payload,
      };
    case type.GET_ALL_BOM_SUB_COMPONENT_TYPE_MASTER:
      return {
        ...state,
        bomSubComponentType: action.payload,
      };
    case type.GET_AUTO_ID_MASTER:
      return {
        ...state,
        autoIdMaster: action.payload,
      };
    case type.GET_ALL_PRODUCTCOUNT_OPTIONS:
      return {
        ...state,
        ProductCountList: action.payload ? action.payload : '',
      };
    case type.GET_PCP_CUSTOM_ATTRIBUTE:
      return {
        ...state,
        pcpCustomAttribute: action.payload,
      };
    case type.CUSTOM_ATTRIBUTE_BOM_LIST:
      return {
        ...state,
        customAttributeBomList: action.payload,
      };
    case type.CUSTOM_ATTRIBUTE_SUB_BOM_LIST:
      return {
        ...state,
        customAttributeSubBomList: action.payload,
      };
    case type.FETCH_TYPE_BASED_CATEGORY:
      const dynamicKey = `catOptions${action.payload.categoryType}`;
      return {
        ...state,
        [dynamicKey]: action.payload.data,
      };
    case type.GET_LENGTH_ACCESS:
      return {
        ...state,
        lengthVisible: action.payload.lengthVisible,
        variableOneName: action.payload.variableOneName,
      };
    case type.GET_LENGTH_IN_USE_STATUS:
      return {
        ...state,
        lengthInUse: action.payload?.inUse === true,
        lengthUsageModules: action.payload?.modules || {},
      };
    case type.GET_ALL_LICENSOR:
      return {
        ...state,
        licensorList: action.payload,
      };
    case type.GET_ALL_LICENSE:
      return {
        ...state,
        licenseList: action.payload,
      };
    case type.GET_LICENSE_DROPDOWN_LIST:
      return {
        ...state,
        licenseDropdownList: action.payload,
      };
    case type.GET_ALL_LIKENESS:
      return {
        ...state,
        likenessList: action.payload,
      };
    case type.GET_ALL_SUB_BRAND:
      return {
        ...state,
        subBrandList: action.payload,
      };
    case type.CLEAR_SUB_BRAND:
      return {
        ...state,
        subBrandList: [],
      };
    case type.GET_SUB_BRAND_ACCESS:
      return {
        ...state,
        subBrandAccess: action.payload,
      };
    case type.GET_MULTI_SUB_BRAND:
      return {
        ...state,
        multiSubBrandList: action.payload,
      };

    case type.GET_ALL_INCOTERMS:
      return {
        ...state,
        incotermsList: action?.payload ? action.payload : [],
      };

    case type.GET_ACTIVE_INCOTERMS:
      return {
        ...state,
        activeIncotermsList: action?.payload ? action.payload : [],
      };
    case type.GET_CUSTOM_ATTRIBUTE_DETAIL:
      return {
        ...state,
        customAttributeDetail: action.payload,
      };
    case type.GET_ALL_PLACEMENT_SUB_BRAND:
      return {
        ...state,
        placementSubBrandList: action.payload,
      };
    case type.GET_PLACEMENT_NAMES:
      return {
        ...state,
        placementNames: action.payload,
      };
    case type.GET_CAT_BASED_ON_PT:
      return {
        ...state,
        catBasedOnPT: !!action.payload,
      };
    case type.GET_BOM_SOURCE_CUSTOM_ATTRIBUTE:
      return {
        ...state,
        bomSourceCustomAttribute: action.payload,
      };
    case type.GET_ALL_COLOUR_GROUPS:
      return {
        ...state,
        colourGroupsList: action.payload,
      };
    case type.GET_COMPOSITION_PROCESS:
      return {
        ...state,
        compositionMasterData: action.payload,
      };
    case type.GET_PRODUCT_TYPE_PROCESS:
      return {
        ...state,
        productTypeProcessData: action.payload,
      };
    case type.GET_BOM_COMPONENT_TYPE:
      return {
        ...state,
        bomComponentTypeData: action.payload,
      };
    case type.GET_MODULE_ORDER_CONFIGS:
      return {
        ...state,
        moduleOrderConfigs: Array.isArray(action.payload) ? action.payload : [],
      }
    case type.GET_ALL_SAMPLE_TYPE_GROUPS:
      return {
        ...state,
        sampleTypeGroupList: action.payload,
      };
    case type.GET_ALL_ADDITIONAL_VARIABLES:
      return {
        ...state,
        additionalVariablesList: action.payload,
      };
    case type.GET_ALL_SIZE_RANGES_MASTER:
      return {
        ...state,
        sizeRangesMasterList: action.payload,
      };
    case type.GET_ALL_PC_TYPE_ADMIN:
      return {
        ...state,
        pcTypeAdminList: action.payload,
      };
    case type.GET_FILTER_SEASONS:
      return {
        ...state,
        filterSeasonList: action.payload,
      };
    default:
      return state;
  }
};

export default SystemMastersReducer;
